import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

/**
 * TODO: Remove when Lux Award is finished
 */
@Component({
  selector: 'fspro-footer-lux',
  imports: [RouterLink],
  templateUrl: './footer-lux.component.html',
  styleUrl: './footer-lux.component.scss',
})
export class FooterLuxComponent {

}
